import { DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { SolicitudService } from './../../service/solicitud/solicitud.service';
import { Component, OnInit } from "@angular/core";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import Swal from "sweetalert2";

@Component({
  selector: 'app-solicitudes',
  templateUrl: './solicitudes.component.html',
  styleUrls: ['./solicitudes.component.scss']
})
export class SolicitudesComponent implements OnInit {

  maxChars = 151;
  form: FormGroup;
  loading: boolean = false;
  numRamdom : any;
  dataRespuesta :any = [];
  dataEnviar :any = {};

  constructor(
    private datePipe: DatePipe,
    private solicitudService: SolicitudService
  ) {
   
  }

  ngOnInit() {
    this.form = new FormGroup({
      
      TipoDocumentoIdentidad: new FormControl('D', []),
      NroDocumentoIdentidad: new FormControl('', [Validators.required, Validators.pattern(/^[0-9]\d{7,10}$/)]),
      Edad: new FormControl('', [Validators.required, Validators.pattern("[0-9]{2,3}$")]),
      NombresCompletos:new FormControl('', [Validators.required]),
      ApellidoPaterno:new FormControl('', [Validators.required]),
      ApellidoMaterno:new FormControl('', [Validators.required]),
      Direccion:new FormControl('', [Validators.required]),
      Departamento:new FormControl('', [Validators.required]),
      Provincia:new FormControl('', [Validators.required]),
      Distrito:new FormControl('', [Validators.required]),
      TelefonoMovil: new FormControl('', [Validators.required, Validators.pattern("^9[0-9]{8}$")]),
      Email: new FormControl('', [Validators.required, Validators.pattern("^[a-zA-Z0-9_.+-]{3,}@[a-zA-Z0-9-]{3,}.[a-zA-Z0-9-.]{2,}$")]),

      NombresCompletosApoderado:new FormControl('', []),
      ApellidoPaternoApoderado:new FormControl('', []),
      ApellidoMaternoApoderado:new FormControl('', []),
      DireccionApoderado:new FormControl('', []),
      DepartamentoApoderado:new FormControl('', []),
      ProvinciaApoderado:new FormControl('', []),
      DistritoApoderado:new FormControl('', []),
      TelefonoMovilApoderado: new FormControl('', [ Validators.pattern("^9[0-9]{8}$")]),
      EmailApoderado: new FormControl('', [ Validators.pattern("^[a-zA-Z0-9_.+-]{3,}@[a-zA-Z0-9-]{3,}.[a-zA-Z0-9-.]{2,}$")]),
      Conformidad:new FormControl(false, [Validators.required]),

      TipoSolicitud:new FormControl('', []),
      Canal:new FormControl('E', []),
      TipoServicio:new FormControl('', []),
      Moneda:new FormControl('0', []),
      Monto:new FormControl('', [Validators.pattern('^-?[0-9]\\d*(\\.\\d{1,2})?$')]),
      Detalle:new FormControl('', [Validators.required,Validators.maxLength(150)]),
      Pedido:new FormControl('', [Validators.required,Validators.maxLength(150)]),
   
    });
  }
  generarNumeroRandom(){
    var min = 1001;
    var max = 9999;
    return this.numRamdom = Math.floor(Math.random()*(max - min)+min);
  }




  enviar() {
    this.loading = true;
    this.dataEnviar.Apoderado = [];
    this.dataEnviar.TipoDocumentoIdentidad = this.form.controls["TipoDocumentoIdentidad"].value
    this.dataEnviar.NroDocumentoIdentidad = this.form.controls["NroDocumentoIdentidad"].value
    this.dataEnviar.Edad = this.form.controls["Edad"].value
    this.dataEnviar.NombresCompletos = this.form.controls["NombresCompletos"].value
    this.dataEnviar.ApellidoPaterno = this.form.controls["ApellidoPaterno"].value
    this.dataEnviar.ApellidoMaterno = this.form.controls["ApellidoMaterno"].value
    this.dataEnviar.Direccion = this.form.controls["Direccion"].value
    this.dataEnviar.Departamento = this.form.controls["Departamento"].value
    this.dataEnviar.Provincia = this.form.controls["Provincia"].value
    this.dataEnviar.Distrito = this.form.controls["Distrito"].value
    this.dataEnviar.TelefonoMovil = this.form.controls["TelefonoMovil"].value
    this.dataEnviar.Email = this.form.controls["Email"].value
    this.dataEnviar.Codigo = this.form.controls["NroDocumentoIdentidad"].value + this.generarNumeroRandom();
    this.dataEnviar.FechaRegistro = this.datePipe.transform(Date(),"yyyy-MM-dd")

    this.dataEnviar.TipoSolicitud = this.form.controls["TipoSolicitud"].value
    this.dataEnviar.Canal = this.form.controls["Canal"].value
    this.dataEnviar.TipoServicio = this.form.controls["TipoServicio"].value
    this.dataEnviar.Moneda = this.form.controls["Moneda"].value
    this.dataEnviar.Monto = this.form.controls["Monto"].value
    this.dataEnviar.Detalle = this.form.controls["Detalle"].value
    this.dataEnviar.Pedido = this.form.controls["Pedido"].value

    if(this.form.controls["Conformidad"].value){
      this.dataEnviar.Conformidad = 'S'
    }

    if(this.form.controls["Edad"].value < 18){

      this.dataEnviar.Apoderado.push(
        {
          'NombresCompletos':this.form.controls["NombresCompletosApoderado"].value,
          'ApellidoPaterno':this.form.controls["ApellidoPaternoApoderado"].value,
          'ApellidoMaterno':this.form.controls["ApellidoMaternoApoderado"].value,
          'Direccion':this.form.controls["DireccionApoderado"].value,
          'Departamento':this.form.controls["DepartamentoApoderado"].value,
          'Provincia':this.form.controls["ProvinciaApoderado"].value,
          'Distrito':this.form.controls["DistritoApoderado"].value,
          'TelefonoMovil':this.form.controls["TelefonoMovilApoderado"].value,
          'Email':this.form.controls["EmailApoderado"].value,
        }
      )

    }

    Swal.fire({
      title: "Espere",
      text: "Guardado Solicitud",
      icon: "info",
      allowOutsideClick: false
    });
    Swal.showLoading();
   
    this.solicitudService.guardarSolicitud(this.dataEnviar)
    .subscribe(resp => {
      this.loading = false;
      this.dataRespuesta = resp;
      Swal.fire({
        title: "Solicitud registrada correctamente",
        html:'<span>N° <strong>'+this.dataRespuesta.Codigo+'</strong></br> Fecha : <b>'+this.datePipe.transform(Date(),"yyyy-MM-dd")+'</b></span>',
        icon: "success",
        allowOutsideClick: false
      }).then(res =>{
        if (res.value == true ){ 
          
        }
      });
    },(err: HttpErrorResponse)=> {
      this.loading = false;
      Swal.fire({
        title: 'Error',
        text: "SOLICITUD NO GUARDADO.",
        icon: "error",
        allowOutsideClick: true
      })
    });

    
  }


}
